import { render, staticRenderFns } from "./M4_S28.vue?vue&type=template&id=63cfc9f4&scoped=true"
import script from "./M4_S28.vue?vue&type=script&lang=js"
export * from "./M4_S28.vue?vue&type=script&lang=js"
import style0 from "./M4_S28.vue?vue&type=style&index=0&id=63cfc9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cfc9f4",
  null
  
)

export default component.exports